/* eslint-disable react/prop-types */

import React from "react";
import SelectInput from "../../../../component/input/SelectInput";
import TextInput from "../../../../component/input/TextInput";

function SafetyQuestions({
  safetyQuestionValues,
  inComingIndexSQ,
  onSafetyQuestionsChanges
}) {
  return (
    <div className="row mt-1 mb-1 ">
      <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12">
        {safetyQuestionValues.name}
      </div>
      <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12">
        <SelectInput
          type="text"
          name="status"
          label="Status"
          required={false}
          textWhite={false}
          isLabeled={false}
          placeholder="Status"
          className="textWhite"
          htmlFor="accidentOnSite"
          value={safetyQuestionValues.status}
          onChange={onSafetyQuestionsChanges(inComingIndexSQ)}
        >
          <option value="">Select status</option>
          <option value="YES">YES</option>
          <option value="NO">NO</option>
          <option value="NOT-AVAILABLE">NOT-AVAILABLE</option>
        </SelectInput>
      </div>
      <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
        <TextInput
          type="text"
          required={false}
          textWhite={false}
          name="description"
          label="Description"
          htmlFor="description"
          placeholder="Description"
          value={safetyQuestionValues.description}
          onChange={onSafetyQuestionsChanges(inComingIndexSQ)}
        />
      </div>
    </div>
  );
}

export default SafetyQuestions;
